enum RoutesList {
    SERVICES = '/',
    FORM = '/form',
}

export default RoutesList
